module.exports = __webpack_public_path__ + "assets/10663aa269f3ca49dcac7f38768558b7.png";